<template>
  <v-dialog
    v-model="dialog"
    eager
    persistent
    :width="$mq | mq({
      mobile: '80vw',
      tablet: '60vw',
      desktop: '30vw',
    })"
  >
    <v-card>
      <v-card-title>
        <v-icon>mdi-alert-box mdi-24px</v-icon>
        <span
          class="headline"
          style="margin: 0 1em;"
        >
          Information
        </span>
      </v-card-title>
      <v-card-text>
        <v-list
          disabled
          flat
          class="ma-4"
        >
          <v-list-item-group>
            <v-list-item
              v-for="(item, i) in demoTextItems"
              :key="i"
            >
              <v-list-item-content>
                <v-list-item-title class="text-wrap mr-2">
                  {{ item.title }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-wrap mr-2">
                  {{ item.content }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <div v-if="demoAdjustments">
          <v-img
            v-if="typeof demoAdjustments.image !== 'undefined'"
            :src="demoAdjustments.image"
            width="50%"
            contain
            style="margin: 2.5% 25%;"
          />
        </div>
      </v-card-text>
      <div v-if="demoAdjustments">
        <v-card-actions
          v-if="typeof demoAdjustments.buttonText !== 'undefined'"
        >
          <v-btn
            color="success"
            outlined
            text
            block
            @click="dialog = false"
          >
            {{ demoAdjustments.buttonText }}
            <!-- {{ $t('various.close') }} -->
          </v-btn>
        </v-card-actions>
      </div>
      <div v-else>
        <v-card-actions>
          <v-btn
            color="success"
            outlined
            text
            block
            @click="dialog = false"
          >
            {{ $t('various.close') }}
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'DemoWarning',
  data() {
    return {
      dialog: true,
      information: this.$appConfig.information,
      responsibility: this.$appConfig.responsibility,
      demoTextItems: this.$appConfig.demoText,
      demoAdjustments: this.$appConfig.demoAdjustment,
    };
  },
  methods: {
  },
};
</script>

<style scoped>

.v-btn {
  width: 3em;
}
</style>
